import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

/**
 * Reusable file upload field with label and selected file name display.
 *
 * Props:
 *   label      - display label
 *   accept     - file types e.g. '.csv,.xlsx'
 *   required   - marks field as required
 *   onChange   - (File|null) => void
 *   file       - currently selected File object
 *   helperText - optional description below the button
 */
export default function FileUploadField({
  label,
  accept = '.csv,.xlsx,.xls',
  required = false,
  onChange,
  file,
  helperText
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography variant="body2" fontWeight={500}>
        {label}
        {required && <span style={{ color: '#d32f2f' }}> *</span>}
      </Typography>

      <Button
        variant="outlined"
        component="label"
        startIcon={<UploadFileIcon />}
        sx={{
          textTransform: 'none',
          justifyContent: 'flex-start',
          maxWidth: 360,
          color: file ? 'success.main' : 'text.secondary',
          borderColor: file ? 'success.main' : 'divider'
        }}
      >
        {file ? file.name : 'Choose File'}
        <input
          type="file"
          hidden
          accept={accept}
          onChange={(e) => onChange(e.target.files[0] || null)}
        />
      </Button>

      {helperText && (
        <Typography variant="caption" color="text.secondary">
          {helperText}
        </Typography>
      )}
    </Box>
  );
}
